export default __webpack_public_path__ + "static/media/IT-Helpdesk-Illustration.c53b0e3b.svg";